import React from "react";
import FormInput from "./FormInput";
import AppButton from "components/AppButton/AppButton";

const FromInputWithButton = props => {
  const { label, className, inputProps, buttonProps, size = "large" } = props;
  return (
    <div className={`d-flex gap-3 ${className}`}>
      <FormInput label={label} containerClassname="mb-0" size={size} {...inputProps} />
      <AppButton size={size} className="rounded-pill px-4 py-0" light {...buttonProps} />
    </div>
  );
};

export default FromInputWithButton;
